import get from "lodash/get";

function isTrue(value) {
  return value === true || value === 1 || value === "1" || value === "YES" || value === "OUI";
}

function isEqual(v1, v2) {
  return (isTrue(v1) && isTrue(v2)) || v1 === v2 || "" + v1 === "" + v2;
}

function isEmpty(value) {
  return value === "" || value === undefined || value === null;
}

function contains(haystack, needle) {
  if (!haystack) return false;
  if (!needle) return false;
  if (typeof haystack === "string") {
    return haystack.toLowerCase().indexOf(needle.toLowerCase()) !== -1;
  } else if (Array.isArray(haystack)) {
    return haystack.indexOf(needle) !== -1;
  }
  return false; // What should we do ?
}

export function evalCondition(condition, values) {
  if (!condition) return true;
  if (typeof condition === "object") {
    switch (condition.op) {
      case "isEqual":
        return isEqual(get(values, condition.key), condition.value);
      case "isNotEqual":
        return !isEqual(get(values, condition.key), condition.value);
      case "contains":
        return contains(get(values, condition.key), condition.value);
      case "doesntContain":
        return !contains(get(values, condition.key), condition.value);
      case "isEmpty":
        return isEmpty(get(values, condition.key));
      case "isNotEmpty":
        return !isEmpty(get(values, condition.key));
      case ">":
      case "<":
      case ">=":
      case "<=": {
        let leftValue = get(values, condition.key);
        if (isEmpty(leftValue) || isEmpty(condition.value)) return false;
        leftValue = parseFloat(leftValue);
        if (isNaN(leftValue)) return false;
        switch (condition.op) {
          case ">":
            return leftValue > condition.value;
          case "<":
            return leftValue < condition.value;
          case ">=":
            return leftValue >= condition.value;
          case "<=":
            return leftValue <= condition.value;
        }
      }
      case "and":
        return evalCondition(condition.left, values) && evalCondition(condition.right, values);
      case "or":
        return evalCondition(condition.left, values) || evalCondition(condition.right, values);
      default: {
        console.warn("unknown op", condition.op);
        return false;
      }
    }
  } else {
    return condition(values);
  }
}
